type FormatNumberProps = {
  locale: string;
  number: number;
};
export const formatNumber = ({ locale, number }: FormatNumberProps): string =>
  new Intl.NumberFormat(locale).format(number);
